export { default as ScrollToTop } from './ScrollToTop';
